export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.207 14.5856C18.207 15.4765 19.2842 15.9227 19.9141 15.2927L22.4999 12.707C22.8904 12.3164 22.8904 11.6833 22.4999 11.2927L19.9141 8.70696C19.2842 8.077 18.207 8.52316 18.207 9.41407L18.207 14.5856Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.70703 12C7.70703 11.7239 7.93089 11.5 8.20703 11.5H18.207V12.5H8.20703C7.93089 12.5 7.70703 12.2761 7.70703 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.20703 12C7.20703 11.4477 7.65475 11 8.20703 11H18.707V13H8.20703C7.65475 13 7.20703 12.5523 7.20703 12Z"
      fill="currentColor"
    />
    <path
      d="M5.79297 9.41436C5.79297 8.52345 4.71583 8.07729 4.08586 8.70725L1.50007 11.293C1.10955 11.6836 1.10955 12.3167 1.50008 12.7073L4.08586 15.293C4.71583 15.923 5.79297 15.4768 5.79297 14.5859L5.79297 9.41436Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.293 12C16.293 12.2761 16.0691 12.5 15.793 12.5L5.79297 12.5L5.79297 11.5L15.793 11.5C16.0691 11.5 16.293 11.7239 16.293 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.793 12C16.793 12.5523 16.3453 13 15.793 13L5.29297 13L5.29297 11L15.793 11C16.3453 11 16.793 11.4477 16.793 12Z"
      fill="currentColor"
    />
    <path
      d="M14.5859 5.79297C15.4768 5.79297 15.923 4.71583 15.293 4.08586L12.7072 1.50008C12.3167 1.10955 11.6835 1.10955 11.293 1.50008L8.7072 4.08586C8.07724 4.71583 8.52341 5.79297 9.41431 5.79297L14.5859 5.79297Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 16.293C11.7239 16.293 11.5 16.0691 11.5 15.793L11.5 5.79297L12.5 5.79297L12.5 15.793C12.5 16.0691 12.2761 16.293 12 16.293Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 16.793C11.4477 16.793 11 16.3453 11 15.793L11 5.29297L13 5.29297L13 15.793C13 16.3453 12.5523 16.793 12 16.793Z"
      fill="currentColor"
    />
    <path
      d="M9.41411 18.207C8.52321 18.207 8.07704 19.2842 8.70701 19.9141L11.2928 22.4999C11.6833 22.8904 12.3165 22.8904 12.707 22.4999L15.2928 19.9141C15.9228 19.2842 15.4766 18.207 14.5857 18.207H9.41411Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7.70703C12.2761 7.70703 12.5 7.93089 12.5 8.20703L12.5 18.207L11.5 18.207L11.5 8.20703C11.5 7.93089 11.7239 7.70703 12 7.70703Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7.20703C12.5523 7.20703 13 7.65475 13 8.20703L13 18.707L11 18.707L11 8.20703C11 7.65475 11.4477 7.20703 12 7.20703Z"
      fill="currentColor"
    />
  </svg>
);
